/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }

  getProfile(): Observable<any> {
    return this.http
      .get(
        `/api/v1/user`
      );
  }

  saveProfile(name: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/user`,
        { name: name }
      );
  }

  changePassword(pw: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/user/changepw`,
        { pw: pw }
      );
  }

  updateNotifications(notifications: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/user/notifications`,
        { notifications: notifications }
      );
  }

  addUser(user: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/user/manage`,
        user
      );
  }

  updateUser(user: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/user/manage`,
        user
      );
  }

  deleteUser(userId: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/user/manage/${userId}`
      );
  }

  reInviteUser(userId: string, inviterId: string): Observable<any> {
    return this.http
    .post(
      `/api/v1/user/manage/reinvite`,
      { user_id: userId, inviter_id: inviterId }
    );
  }

  botReviewEmail(accountId: string, accountName: string, underReview: any, approveStatus: string): Observable<any> {
    return this.http
    .post(
      `/api/v1/user/review`,
      {account_id: accountId, account_name: accountName, under_review: underReview, approve_status: approveStatus}
    );
  }

  getUsersWithBotReviewQueue(accountId: string) {
    return this.http
    .get(
      `/api/v1/user/botreview/${accountId}`
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/user.service.ts